import { PaymentHistoryGroup } from '@/features/Finance';
import { formatMoney, formatValue } from '@/lib/formatters';
import {
  OperationHistoryDetailedGroup,
  OperationHistoryDetailedItem,
  OperationHistoryItemType,
  OperationHistorySummaryItem
} from './types';

export const OPERATION_HISTORY_SUMMARY_LIMIT = 2;

export const getOperationHistoryItemTypeByAmount = (amount: number): OperationHistoryItemType => {
  return amount > 0 ? 'credit' : 'debit';
};

export const mapPaymentHistoryGroupsToOperationHistoryGroups = (
  groups: PaymentHistoryGroup[] | null | undefined
): OperationHistoryDetailedGroup[] => {
  if (!groups?.length) return [];

  return groups.map((group, groupIndex) => {
    const number = formatValue({ value: group.shipmentNumber });
    const budget = formatMoney({ currency: 'RUB', value: group.budget });
    const summaryAmount = formatMoney({
      currency: 'RUB',
      signed: true,
      value: -group.spent
    });
    const summary = `${summaryAmount} | ${budget}`;

    return {
      id: group.shipmentId ?? group.shipmentNumber ?? `group-${groupIndex}`,
      items: (group.items ?? []).map((item): OperationHistoryDetailedItem => ({
        amount: formatMoney({
          currency: 'RUB',
          signed: true,
          value: item.amount
        }),
        date: item.date,
        document: item.document,
        id: item.id,
        title: item.title ?? 'Операция',
        type: getOperationHistoryItemTypeByAmount(item.amount)
      })),
      number,
      summary
    };
  });
};

export const mapPaymentHistoryGroupsToOperationHistoryItems = (
  groups: PaymentHistoryGroup[] | null | undefined
): OperationHistorySummaryItem[] => {
  if (!groups?.length) return [];

  return groups.flatMap((group) => (
    (group.items ?? []).map((item): OperationHistorySummaryItem => ({
      amount: formatMoney({
        currency: 'RUB',
        signed: true,
        value: item.amount
      }),
      date: item.date,
      document: item.document,
      id: item.id,
      shipmentNumber: formatValue({ value: group.shipmentNumber ?? item.document }),
      title: item.title ?? 'Операция',
      type: getOperationHistoryItemTypeByAmount(item.amount)
    }))
  ));
};

export const getOperationHistorySummaryItems = (
  items: OperationHistorySummaryItem[]
): OperationHistorySummaryItem[] => {
  return items.slice(0, OPERATION_HISTORY_SUMMARY_LIMIT);
};

export const filterOperationHistoryGroupsBySearch = (
  groups: OperationHistoryDetailedGroup[],
  search: string
): OperationHistoryDetailedGroup[] => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) return groups;

  return groups.filter((group) => group.number.toLowerCase().includes(normalizedSearch));
};